import { FC } from 'react'

import {
  LoadingContainer,
  Modal,
  Input,
  Panels,
  Pagination,
  Bar,
} from 'peach/components'
import { ListSubroutes, useParams } from 'peach/router'

import { useQueryString } from 'core/hooks'
import { Page } from 'core/components'
import {
  useInternalTeamsGet,
  useInternalTeamsCreate,
  PickRequired,
} from 'core/types'
import { InternalTeamsGetVariables } from 'core/types/operations'

const CompanyTeams: FC = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<InternalTeamsGetVariables['query']>,
      'limit' | 'offset'
    >
  >({
    limit: 50,
    offset: 0,
  })

  const {
    data: teams,
    pagination: { total: count } = {},
    isLoading,
    refetch,
  } = useInternalTeamsGet({ companyId, query })

  const { mutateAsync: addTeam } = useInternalTeamsCreate({ companyId })

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              maxPagesVisible={16}
              offset={query.offset ?? 0}
              onChange={(offset) => setQuery({ offset })}
              total={count}
            />
          }
          right={
            <Modal
              onSubmit={async (team) => {
                await addTeam(team)
                await refetch()
              }}
              title='Add Team'
            >
              <Input formKey='name' />
            </Modal>
          }
          title='Teams'
        />
      }
    >
      <LoadingContainer loading={isLoading}>
        <Page variant='full'>
          <ListSubroutes json={teams} title='Teams' />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyTeams
